import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Timeformat from "../../utils/Timeformat";
import MachineStates from "../../utils/MachineStates";
import TableContainer from "../../utils/TableContainer";
import StaticFunctions from "../../utils/StaticFunctions";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";

class MachineTable extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.array.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {};

        this.translate = this.props.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    getTableColumns() {

        return [
            {
                key: 'status',
                nameKey: 'status',
            },
            {
                key: 'img',
                nameKey: 'design',
            },
            {
                key: 'design',
                nameKey: 'design',
                sortType: 'string',
            },
            {
                key: 'id',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'alias',
                nameKey: 'machineName',
                sortType: 'string',
            },
            {
                key: 'location',
                nameKey: 'location',
                sortType: 'string',
            },
            {
                key: 'rpm',
                nameKey: 'rpm',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'stitchnumber',
                nameKey: 'stitch',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'stitchcounter',
                nameKey: 'totalStitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'remainingTime',
                nameKey: 'estimatedRemainingTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'lastTransmission',
                nameKey: 'lastTransmission',
                classes: 'text-right',
                sortType: 'datetime',
            },
        ];

    }

    getTableRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const machines = this.props.machines;
        const rows = [];

        for (let i = 0; i < machines.length; i++) {
            let rowTemp = machines[i];
            let status = MachineStates.getStatusType(rowTemp.status);
            let machineStatus = MachineStates.get(rowTemp.status);
            let machineTranslationKey = machineStatus ? machineStatus.translationKey : 'status_' + rowTemp.status;
            let remainingTime = (rowTemp.status !== 1001) ? this.getRemainingTime(rowTemp) : null;
            let lastTransmission = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push({
                statusMsg: status,
                status: <span><i>{status}</i> <span>{this.translate(machineTranslationKey)}</span></span>,
                img: <DesignPreviewContainer baseData={this.props.baseData} designId={rowTemp.pattern_number} designStitches={rowTemp.pattern_stitchcounter} />,
                id: rowTemp.machine_id,
                alias: rowTemp.alias,
                location: this.getLocationById(rowTemp.id_location),
                design: rowTemp.pattern_number,
                rpm: StaticFunctions.formatedNumber(rowTemp.rotation_speed),
                stitchnumber: StaticFunctions.formatedNumber(rowTemp.pattern_stitchnumber),
                stitchcounter: StaticFunctions.formatedNumber(rowTemp.pattern_stitchcounter),
                remainingTime: StaticFunctions.convertSecondsToFormatedString(remainingTime, true),
                lastTransmission: lastTransmission,
            });
        }

        return rows;

    }

    getRemainingTime(machine) {

        const patternStitches = machine.pattern_stitchcounter;
        const stitches = (machine.status === 1012) ? machine.pattern_stitchcounter : machine.pattern_stitchnumber;

        const rpm = this.props.baseData.companies.currentCompany.machine_rpm / 60;
        const remainingStitches = patternStitches - stitches;

        return (remainingStitches > 0) ? Math.round(remainingStitches / rpm) : 0;    //  Time in seconds.

    }

    getLocationById(locationId) {

        let location = '-';
        let locations = this.props.baseData.locations;

        locations.find((locationData) => {
            if (parseInt(locationData.id) === parseInt(locationId)) location = locationData.name;
        });

        return location;

    }

    render() {

        if (this.props.machines.length > 0) {
            let tableColumns = this.getTableColumns();
            let tableRows = this.getTableRows();

            return (
                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                    fillGaps="-"
                    translate={this.translate}
                    onClick={this.props.onClick}
                />
            );
        }

        return 'No design found!';

    }

}

export default MachineTable;
